import { Box, Typography } from '@mui/material';
import React from 'react';

import { appVersionLabel } from '../../version';
import { useUserStore } from '../stores/userStore';
import { ColorSafeHtmr } from 'react-ui-components/components/ColorSafeHtmr';

export const CopyrightComponent: React.FC<{
  ml?: number;
}> = ({ ml }) => {
  const { displayContentConfig } = useUserStore();
  const copyMessage =
    displayContentConfig?.copyrightMessage || 'Copyright (c) 2024 WinFacil Corp';

  return (
    <Box component="section" sx={{ p: 2 }} style={{ marginLeft: ml }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 1 }}>
        <Typography variant="caption" sx={{ fontWeight: 600, letterSpacing: 0.4 }}>
          v{appVersionLabel}
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <ColorSafeHtmr html={copyMessage} />
        </Box>
      </Box>
    </Box>
  );
};
